module.exports = __webpack_public_path__ + "img/risk1.e77ba794.png";